<template>
    <div>
        <Breadcrumbs main="Services" title="Contact Us"/>
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="user-profile">
              <div class="row">
                <!-- user profile first-style start-->
                <div class="col-sm-12">
                  <div class="card hovercard text-center">
                    <div class="cardheader"></div>
                    <div class="user-image">
                      <div class="avatar-image">
                        <div>
                            <feather type="headphones" style="width:80px" class="text-danger mt-3"></feather>
                        </div>
                      </div>
                    </div>
                    <div class="info mt-4">
                     <div class="cal-desc text-center card-body">
                        <h5 class="f-w-600">
                            Have a challenge or require support?
                        </h5>
                        <p class="text-muted mt-3 mb-0">You can reach us through our multiple channels. <br>Our only interest is you!</p>
                        <p class="mt-3">
                            <i class="fa fa-phone text-danger"></i> &nbsp;+234 908 793 7417 <br><i class="fa fa-phone text-danger"></i> &nbsp;+234 700 825 2265<br>
                            <a href="mailto:tajconnect@tajbank.com"><i class="fa fa-envelope text-danger"></i> &nbsp;tajconnect@tajbank.com</a>
                        </p>
                    </div>
                    </div>
                  </div>
                </div>
                <!-- user profile first-style end-->
              </div>
            </div>
          </div>
        <!-- Container-fluid Ends-->
    </div>
</template>

<script>
  export default {
  };
</script>
<style scoped>

.user-profile .hovercard .cardheader {
    background: url(../../assets/TAJimages/banner-bg8.jpeg);
    background-size: cover;
    background-position: 10%;
}
.avatar-image {
    margin: 0 auto;
    border-radius: 50%;
    background-color: #fff;
    height: 125px;
    width: 125px;
    margin-top: -60px !important;
    border: 1px solid #ecf3fa
}
</style>